import { combineReducers } from "@reduxjs/toolkit";
import dashboardSlice from "./dashboard/dashboardSlice";
import dijikolaySlice from "./dijikolay/dijikolaySlice";
import clientsSlice from "./clients/clientsSlice";

const rootReducer = combineReducers({
    dashboard: dashboardSlice,
    dijikolay: dijikolaySlice,
    clients: clientsSlice
});

export default rootReducer;